import React from 'react';
import Typography from '@material-ui/core/Typography';
import ShortTextIcon from '@material-ui/icons/ShortText';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Form, Field} from 'react-final-form';
import {Section, Text, TextEditor, Explanation_text} from '../../../../components';
import {connect} from 'react-redux';

function ShortCodes(props){

  let initial_values={};

  function onSubmit(params){
    let text=params.text;
    if(text.slice(0, 3)=='<p>'){text=params.text.slice(3, params.text.length);
        if(text.split('<p>')[0].includes('</p>')==true){text=text.replace('</p>', '')}else{text=text.slice(0, text.length - 3);}
    }
    params.text=text;
    if(params.workspace_share==undefined){params.workspace_share=false;}
    if(props.match.params.id!=undefined){props.updateShortCode(props.match.params.id, params);}
    else{props.createShortCode(params);}
    props.history.push('/email/shortCodes');
  }

  let short_code=undefined; if(props.short_codes!=undefined && props.match.params.id!=undefined){for(let key in props.short_codes){if(props.short_codes[key].id==props.match.params.id){short_code=props.short_codes[key]; break;}}}

  if(short_code!=undefined){initial_values=short_code;}


  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values}
    >
      {form_props => (
          <form onSubmit={form_props.handleSubmit}>
            <Section icon={<ShortTextIcon/>} maxWidth='600px' title={(props.match.params.id==undefined)?'New short code':'Edit short code'} action={<Button  variant='contained' onClick={()=>{props.history.push('/email/shortCodes')}}>Exit</Button>}>
              <div style={{maxWidth:'300px', width:'100%', marginLeft:'-10px'}}><Text required title='Name' name='name'/></div>
              <div style={{maxWidth:'300px', width:'100%', marginLeft:'0px', marginTop:'10px'}}><Field name='unique_code'>{(f)=><TextField required label='Unique code' size='small' variant='outlined' value={f.input.value} onChange={(e)=>{let v=e.target.value.replace(/[^a-zA-Z0-9. _]/g, "").toUpperCase(); v=v.replace(' ','_'); f.input.onChange(v)}} style={{backgroundColor:'#f7f9fc'}}/>}</Field></div>
              <div style={{marginTop:'10px', marginBottom:'10px'}}><Field name='workspace_share'>{(f)=><FormControlLabel control={<Checkbox style={{marginLeft:'0px'}} disabled={((short_code!=undefined && props.me!=undefined && short_code.user_id==props.me.id) || props.match.params.id==undefined)?false:true} checked={f.input.value} onChange={f.input.onChange} name="workspace" color="primary"/>} label="Share with workspace"/>}</Field></div>
              <div style={{marginTop:'10px', marginBottom:'10px'}}><Typography color='primary'>Text</Typography></div>
              <div style={{marginTop:'10px', marginBottom:'10px', paddingLeft:'10px'}}><Explanation_text text={'templates_placeholder_explanation'}/></div>
              <div style={{maxWidth:'600px', width:'100%', marginLeft:'0px'}}><Field name='text'>{(f)=><TextEditor required value={f.input.value} onChange={f.input.onChange}/>}</Field></div>
              <div style={{width:'100%', display:'flex', justifyContent:'center', marginTop:'30px'}}><Button variant='contained' color='primary' onClick={form_props.form.submit}>Save</Button></div>
            </Section>
          </form>
      )}
    </Form>
  );
}


export default connect(ss, dd)(ShortCodes)



function ss(state){
  return{
    me:state.account.me,
    short_codes:state.templates.short_codes
  }
}

function dd(dispatch){
  return{
    getShortCode:(id)=>{dispatch({type:'REQUEST_GET_SHORT_CODE', id:id})},
    createShortCode:(data)=>{dispatch({type:'REQUEST_CREATE_SHORT_CODE', payload:data})},
    updateShortCode:(id, data)=>{dispatch({type:'REQUEST_UPDATE_SHORT_CODE', id:id, payload:data})}
  }
}
